import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/issue.png'
import _imports_1 from '@/assets/images/idea.png'
import _imports_2 from '@/assets/images/other.png'


const _hoisted_1 = { class: "flex justify-between w-full my-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "problema",
    class: "w-full"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-medium mt-1 text-gray-800" }, "Problema", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "problema",
    class: "w-full"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "font-medium mt-1 text-gray-800" }, "Ideia", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "problema",
    class: "w-full"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "font-medium mt-1 text-gray-800" }, "Outro", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = () => _ctx.setFeedbackType('ISSUE')),
      type: "button",
      class: "rounded-xl hover:bg-gray-100 bg-brand-gray flex flex-col justify-center items-center p-5 w-28 cursor-pointer focus:outline-none"
    }, _hoisted_4),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = () => _ctx.setFeedbackType('IDEA')),
      type: "button",
      class: "rounded-xl hover:bg-gray-100 bg-brand-gray flex flex-col justify-center items-center p-5 w-28 cursor-pointer focus:outline-none"
    }, _hoisted_7),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = () => _ctx.setFeedbackType('OTHER')),
      type: "button",
      class: "rounded-xl hover:bg-gray-100 bg-brand-gray flex flex-col justify-center items-center p-5 w-28 cursor-pointer focus:outline-none"
    }, _hoisted_10)
  ]))
}